/**
 * Actions designed for persistent editing of a selected chart, i.e. chart designer on report editor
 */

export enum ChartDesignerActionType {
  UpdateEncoding = '[Designer] UpdateEncoding',

  MinimizeDataPane = '[Designer] MinimizeDataPane',
  MaximizeDataPane = '[Designer] MaximizeDataPane',
  MinimizeChartPane = '[Designer] MinimizeChartPane',
  MaximizeChartPane = '[Designer] MaximizeChartPane',

  // Table Panes actions - used for PTQC data pane
  MinimizeTableDataPane = '[Designer] MinimizeTableDataPane',
  MaximizeTableDataPane = '[Designer] MaximizeTableDataPane',

  SetPagingOffset = '[Designer] SetPagingOffset',
  SetPageSize = '[Designer] SetPageSize',
  SetSelectedColumn = '[Designer] SetSelectedColumn',
  SetTableColumnSearch = '[Designer] SetTableColumnSearch',

  /// Calculations
  OpenCalcEditor = '[Designer] OpenCalcEditor',
  CloseCalcEditor = '[Designer] CloseCalcEditor',
}
